import React, { Fragment } from 'react'
import { Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import CollapseCardTable from '../CollapseCard/CollapseCardTable';
import TimeTrackingHeader from './timeTracking/TimeTrackingHeader';
import TimeTrackingNewEntry from './timeTracking/TimeTrackingNewEntry';
import TimeTrackingEstimate from './timeTracking/TimeTrackingEstimate';
import TimeTrackingEditEntry from './timeTracking/TimeTrackingEditEntry';
import TimeTrackingStandardRow from './timeTracking/TimeTrackingStandardRow';

class ClientTimeWorkflow extends React.Component {

    constructor(props) {
        super(props);
        const d = new Date();

        this.blankTaskTimeTracking = {
            id: 0,
            workflowId: 0,
            date: d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(),
            beginTimestamp: '',
            endTimestamp: '',
            duration: '',
            notes: '',
            employeeId: 0,
            user: {
                firstName: '',
                lastName: '',
                user: ''
            },
            employee: {
                firstName: '',
                lastName: '',
                employeeId: 0,
                active: true
            },
            userSetDuration: false,
            userPreventSetDuration: false,
        }

        this.state = {
            isLoaded: false,
            activeRowId: 0,
            addTaskTimeTrackingId: 0,
            editTaskTimeTrackingId: 0,
            addTaskTimeTracking: { ...this.blankTaskTimeTracking },
            editTaskTimeTracking: { ...this.blankTaskTimeTracking },
            addWorkflowId: 0
        };
    }

    onSetAdd = () => {
        this.props.log('ClientTimeWorkflow.js/onSetAdd');
        this.setState({
            addTaskTimeTracking: { ...this.blankTaskTimeTracking }
        })
    }

    onSetEdit = (obj, workflowId) => {
        this.props.log('ClientTimeWorkflow.js/onSetEdit (obj,workflowId)', obj, workflowId);
        this.setState({
            editTaskTimeTracking: {
                ...obj,
                workflowId: workflowId,
                employeeId: (obj.employee != null) ? obj.employee[0].employeeId : 0,
                userSetDuration: (obj.beginTimestamp === '' && obj.endTimestamp === ''),
                userPreventSetDuration: (obj.beginTimestamp !== '' && obj.endTimestamp !== '')
            },
            editTaskTimeTrackingId: obj.id
        })
    }

    onHandleAdd = () => {
        this.props.log('ClientTimeWorkflow.js/onHandleAdd');
        fetch('/api/clientTaskTimeTracking/', {
            method: 'POST',
            body: JSON.stringify({
                clientId: this.props.clientReports.clientId,
                workflowId: this.state.addWorkflowId,
                clientTaskId: this.state.addTaskTimeTrackingId,
                date: this.state.addTaskTimeTracking.date,
                beginTimestamp: this.state.addTaskTimeTracking.beginTimestamp,
                endTimestamp: this.state.addTaskTimeTracking.endTimestamp,
                duration: this.state.addTaskTimeTracking.duration,
                notes: this.state.addTaskTimeTracking.notes,
                employeeId: this.state.addTaskTimeTracking.employeeId,
                userAuth0: this.props.user,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success && results.data > 0) {
                    this.props.getClientReports();
                    this.props.addToast('Time entry added successfully.', 5, 'success')
                    this.setState({
                        addTaskTimeTrackingId: 0,
                        addWorkflowId: 0,
                        addTaskTimeTracking: { ...this.blankTaskTimeTracking }
                    })
                } else {
                    this.props.addToast('Unable to add time entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onHandleEdit = (id) => {
        this.props.log('ClientTimeWorkflow.js/onHandleEdit (id)', id);
        fetch('/api/clientTaskTimeTracking/' + id, {
            method: 'PUT',
            body: JSON.stringify({
                clientId: this.props.clientReports.clientId,
                workflowId: this.state.editTaskTimeTracking.workflowId,
                clientTaskId: this.state.editTaskTimeTrackingId,
                date: this.state.editTaskTimeTracking.date,
                beginTimestamp: this.state.editTaskTimeTracking.beginTimestamp,
                endTimestamp: this.state.editTaskTimeTracking.endTimestamp,
                duration: this.state.editTaskTimeTracking.duration,
                notes: this.state.editTaskTimeTracking.notes,
                employeeId: this.state.editTaskTimeTracking.employeeId,
                userAuth0: this.props.user,
                isComplete: this.state.editTaskTimeTracking.isComplete
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.getClientReports();
                    this.props.addToast('Time entry updated successfully.', 5, 'success')
                    this.setState({
                        editTaskTimeTrackingId: 0,
                        editTaskTimeTracking: { ...this.blankTaskTimeTracking }
                    })
                } else {
                    this.props.addToast('Unable to update time entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onHandleDelete = (id) => {
        this.props.log('ClientTimeWorkflow.js/onHandleDelete (id)', id);
        fetch('/api/clientTaskTimeTracking/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.getClientReports();
                    this.props.addToast('Time entry deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete time entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    calculateDuration = (type) => {
        this.props.log('ClientTimeWorkflow.js/calculateDuration (type)', type);
        let duration = '';
        const tt = (type === 'edit') ? this.state.editTaskTimeTracking : this.state.addTaskTimeTracking;
        if (tt.beginTimestamp !== '' && tt.endTimestamp !== '') {
            const [beginHours, beginMinutes] = tt.beginTimestamp.split(':').map(item => parseInt(item));
            const [endHours, endMinutes] = tt.endTimestamp.split(':').map(item => parseInt(item));
            duration = Math.max(((((endHours * 60) + endMinutes) - ((beginHours * 60) + beginMinutes)) / 60), 0).toFixed(2);
        } else {
            return '';
        }
        this.setState((prevState) => {
            let sel = { ...prevState };
            if (type === 'edit') {
                sel.editTaskTimeTracking.duration = duration;
            } else {
                sel.addTaskTimeTracking.duration = duration;
            }
            return sel;
        })
    }

    onChange = (e, type) => {
        this.props.log('ClientTimeWorkflow.js/onChange (e, type)', e, type);
        e.persist();
        let thisTaskTimeTracking = (type === 'edit') ? this.state.editTaskTimeTracking : this.state.addTaskTimeTracking;
        switch (e.target.name) {
            case "beginTimestamp": case "endTimestamp":
                thisTaskTimeTracking[e.target.name] = e.target.value;
                thisTaskTimeTracking['userPreventSetDuration'] = (e.target.value !== '' || thisTaskTimeTracking['beginTimestamp'] !== '' || thisTaskTimeTracking['endTimestamp'] !== '') ? true : false;
                break;
            case "duration":
                thisTaskTimeTracking[e.target.name] = e.target.value;
                thisTaskTimeTracking['userSetDuration'] = (e.target.value !== '') ? true : false;
                break;
            case "isComplete":
                thisTaskTimeTracking['isComplete'] = !thisTaskTimeTracking['isComplete'];
                break;
            default:
                thisTaskTimeTracking[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editTaskTimeTracking: thisTaskTimeTracking } : { addTaskTimeTracking: thisTaskTimeTracking };
        }, () => this.calculateDuration(type));
    }

    render = () => {
        this.props.info('ClientTimeWorkflow.js/render');
        return (
            <>
                {this.props.clientReports.workflows != null && this.props.clientReports.workflows.filter(workflow => workflow.duration === this.props.time).length > 0 ? (<>
                    {this.props.clientReports.workflows.filter(workflow => workflow.duration === this.props.time)
                        .map((workflow, workflowIndex) => (
                            <Table key={workflowIndex} className="mb-5">
                                <tbody>
                                    <CollapseCardTable
                                        title={"Workflow: " + workflow.name}
                                        colSpan={3}
                                        level={2}
                                        total={workflow.timeTracking != null ? Math.round([...workflow.timeTracking].map(item => item.duration).reduce(
                                            (previousValue, currentValue) => previousValue + currentValue, 0) * 100) / 100 : ''}
                                        childElements={workflow.timeTracking != null ? workflow.timeTracking.length : 0}
                                        open={false}
                                    >

                                        <TimeTrackingEstimate
                                            {...this.props}
                                            workflowId={workflow.id}
                                            type={workflow}
                                        />

                                        <TimeTrackingHeader
                                            {...this.props}
                                            addTaskTimeTrackingId={this.state.addTaskTimeTrackingId}
                                            addWorkflowId={this.state.addWorkflowId}
                                            taskId={0}
                                            workflowId={workflow.id}
                                            cb={(obj) => this.setState(obj)}
                                        />

                                        <TimeTrackingNewEntry
                                            {...this.props}
                                            addTaskTimeTrackingId={this.state.addTaskTimeTrackingId}
                                            workflowId={workflow.id}
                                            taskId={0}
                                            addWorkflowId={this.state.addWorkflowId}
                                            addTaskTimeTracking={this.state.addTaskTimeTracking}
                                            onChange={this.onChange}
                                            onHandleAdd={this.onHandleAdd}
                                            cb={(obj) => this.setState(obj)}
                                        />

                                        {workflow.timeTracking != null ? workflow.timeTracking.map(tt => {
                                            if (tt.id === this.state.editTaskTimeTrackingId && workflow.id === this.state.editTaskTimeTracking.workflowId) {
                                                return (
                                                    <TimeTrackingEditEntry
                                                        key={tt.id}
                                                        {...this.props}
                                                        editTaskTimeTracking={this.state.editTaskTimeTracking}
                                                        onChange={this.onChange}
                                                        onHandleEdit={this.onHandleEdit}
                                                        cb={(obj) => this.setState(obj)}
                                                        blankTaskTimeTracking={this.blankTaskTimeTracking}
                                                        id={tt.id}
                                                    />
                                                );
                                            } else {
                                                return (
                                                    <TimeTrackingStandardRow
                                                        key={tt.id}
                                                        {...this.props}
                                                        onHandleDelete={this.onHandleDelete}
                                                        onSetEdit={this.onSetEdit}
                                                        tt={tt}
                                                        workflowId={workflow.id}
                                                    />
                                                )
                                            }
                                        }) : <></>}

                                    </CollapseCardTable>
                                    {workflow.tasks.filter(task => task.id != null).map((task, taskIndex) => (<Fragment key={taskIndex}>
                                        <tr>
                                            <td colSpan={5} className="pt-3 border-top-0"></td>
                                        </tr>
                                        <CollapseCardTable
                                            className="pl-3"
                                            title={"Task: " + task.name}
                                            colSpan={3}
                                            total={task.timeTracking != null ? Math.round([...task.timeTracking].map(item => item.duration).reduce(
                                                (previousValue, currentValue) => previousValue + currentValue, 0) * 100) / 100 : ''}
                                            childElements={task.timeTracking != null ? task.timeTracking.length : 0}
                                            open={false}
                                        >

                                            <TimeTrackingEstimate
                                                {...this.props}
                                                workflowId={workflow.id}
                                                taskIndex={taskIndex}
                                                type={task}
                                            />

                                            <TimeTrackingHeader
                                                {...this.props}
                                                addTaskTimeTrackingId={this.state.addTaskTimeTrackingId}
                                                addWorkflowId={this.state.addWorkflowId}
                                                taskId={task.id}
                                                workflowId={workflow.id}
                                                cb={(obj) => this.setState(obj)}
                                            />

                                            <TimeTrackingNewEntry
                                                {...this.props}
                                                addTaskTimeTrackingId={this.state.addTaskTimeTrackingId}
                                                workflowId={workflow.id}
                                                taskId={task.id}
                                                addWorkflowId={this.state.addWorkflowId}
                                                addTaskTimeTracking={this.state.addTaskTimeTracking}
                                                onChange={this.onChange}
                                                onHandleAdd={this.onHandleAdd}
                                                cb={(obj) => this.setState(obj)}
                                            />

                                            {task.timeTracking != null ? task.timeTracking.map(tt => {
                                                if (tt.id === this.state.editTaskTimeTrackingId && workflow.id === this.state.editTaskTimeTracking.workflowId) {
                                                    return (
                                                        <TimeTrackingEditEntry
                                                            key={tt.id}
                                                            {...this.props}
                                                            editTaskTimeTracking={this.state.editTaskTimeTracking}
                                                            onChange={this.onChange}
                                                            onHandleEdit={this.onHandleEdit}
                                                            cb={(obj) => this.setState(obj)}
                                                            blankTaskTimeTracking={this.blankTaskTimeTracking}
                                                            id={tt.id}
                                                        />
                                                    );
                                                } else {
                                                    return (
                                                        <TimeTrackingStandardRow
                                                            key={tt.id}
                                                            {...this.props}
                                                            onHandleDelete={this.onHandleDelete}
                                                            onSetEdit={this.onSetEdit}
                                                            tt={tt}
                                                            workflowId={workflow.id}
                                                        />
                                                    )
                                                }
                                            }) : <></>}

                                        </CollapseCardTable>
                                    </Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        ))}</>) : <>No workflows defined</>}
            </>
        )
    }
}

export default ClientTimeWorkflow;